// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"styles_progressContainer__3IQcA","totalProgress":"styles_totalProgress__2j6FP","correctProgress":"styles_correctProgress__235kn"};